import React from "react";
import infoCircle from "../../assets/info-circle.svg";
import TagInput from "../TagInput";
import { imageUrl } from "../../utils/helper";
import MediaPickerModal from "../MediaPickerModal";

const OGFields = ({
  values,
  errors,
  touched,
  handleChange,
  handleBlur,
  setFieldValue,
  showMediaPicker,
  setShowMediaPicker,
}) => (
  <div className="theme-card p-4 mb-3">
    <div className="card-title pb-3">OG Tags</div>
    <div className="frm-group">
      <label className="frm-label d-flex align-items-center">
        OG Tag Title
        <img
          className="ms-2"
          src={infoCircle}
          alt="Info"
          title="Add OG Tag Title"
        />
      </label>
      <input
        type="text"
        name="og_tags.title"
        className="frm-input"
        placeholder="Enter OG Tag title"
        value={values.og_tags?.title || ""}
        onChange={handleChange}
        onBlur={handleBlur}
      />
      {/* {touched.og_tags.title && errors.og_tags.title && <div className="input-error">{errors.og_tags.title}</div>} */}
    </div>
    <div className="frm-group">
      <label className="frm-label d-flex align-items-center">
        OG Tag URL
        <img
          className="ms-2"
          src={infoCircle}
          alt="Info"
          title="Add OG Tag URL"
        />
      </label>
      <input
        type="text"
        name="og_tags.url"
        className="frm-input"
        placeholder="Enter OG Tag URL"
        value={values?.og_tags?.url || ""}
        onChange={handleChange}
        onBlur={handleBlur}
      />
    </div>
    <div className="frm-group">
      <label className="frm-label d-flex align-items-center">
        OG Tag Description
        <img
          className="ms-2"
          src={infoCircle}
          alt="Info"
          title="Add OG Tag Description"
        />
      </label>
      <textarea
        name="og_tags.desc"
        className="frm-input"
        rows={3}
        placeholder="Enter OG Tag Description"
        value={values?.og_tags?.desc}
        onChange={handleChange}
        onBlur={handleBlur}
      />
    </div>
    <div className="frm-group">
      <label className="frm-label">OG Tag Image</label>

      <div
        className="pointer"
        style={{
          width: "100%",
          height: "200px",
          borderRadius: "12px",
          overflow: "hidden",
          cursor: "pointer",
        }}
        onClick={() => setShowMediaPicker(true)}
      >
        {values?.og_tags?.image ? (
          <img
            src={imageUrl(values.og_tags?.image)}
            alt="image preview"
            style={{ width: "100%", height: "100%", objectFit: "cover" }}
          />
        ) : (
          <div
            style={{
              width: "100%",
              height: "100%",
              borderRadius: "12px",
              background: "#f5f5f5",
              color: "#777",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: "14px",
            }}
          >
            Image
          </div>
        )}
      </div>
    </div>
    {showMediaPicker && (
      <MediaPickerModal
        show={showMediaPicker}
        onClose={() => setShowMediaPicker(false)}
        onSelect={(mediaUrl) => {
          setFieldValue("og_tags.image", mediaUrl);
          setShowMediaPicker(false);
        }}
      />
    )}
  </div>
);

export default OGFields;
